export default __webpack_public_path__ + "static/media/LAS0030.34I107151_-17544_0.691c44ac.jpg";